import React, { Fragment } from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import { NoDataValue, NoRatedView } from "./constants";
// import SkillScoreChart from "../SkillScoreChart";

const AnalyticsCard = ({ skillAnalytics, defaultView }) => {
  const classes = useStyles();
  const getClassName = (title) => {
    switch (title) {
      case "Start":
        return classes.start;
      case "Stop":
        return classes.pause;
      case "Continue":
        return classes.continue;
      default:
        return classes.start;
    }
  };
  const skillAnalyticsCard = () =>
    skillAnalytics?.analytics?.map((data, index) => {
      const { title, detailsHTML } = data;
      const noData = NoDataValue.find(({ type }) => type === title);
      return (
        <Grid item xs={12} sm={4} key={index} className="analytics-card">
          <Box
            borderRadius="borderRadius"
            className={`${getClassName(title)} ${classes.cardContent}`}
            height="100%"
          >
            {detailsHTML ? (
              <Fragment>
                <Box className={classes.title} p={1.5}>
                  <Typography variant="h6" className="font-14 font-semibold">
                    {title}
                  </Typography>
                </Box>
                <Box className={classes.content}>
                  <div
                    className={classes.formHint}
                    dangerouslySetInnerHTML={{
                      __html: detailsHTML ? detailsHTML : "",
                    }}
                  />
                </Box>
              </Fragment>
            ) : (
              <Box
                className={classes.emptyState}
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
              >
                {noData?.icon}
                <Typography
                  variant="subtitle2"
                  className="font-13 font-semibold"
                >
                  {noData?.title}
                </Typography>
                <Typography variant="body2" className="font-12">
                  {noData?.desc}
                </Typography>
              </Box>
            )}
          </Box>
        </Grid>
      );
    });

  // Not rated
  const emptyState = () =>
    NoRatedView.map((res) => (
      <Grid item xs={12} sm={4} className="analytics-card">
        <Box
          borderRadius="borderRadius"
          className={`${classes.cardContent}`}
          height="100%"
        >
          <Box
            className={classes.emptyState}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            {/* <TagSkillIcon /> */}
            {res?.icon}
            <Typography variant="subtitle2" className="font-13 font-semibold">
              {res?.title}
            </Typography>
            <Typography variant="body2" className="font-12">
              {res?.desc}
            </Typography>
          </Box>
        </Box>
      </Grid>
    ));

  return (
    <Grid container spacing="2" id="startStopWidgetImage">
      {defaultView ? skillAnalyticsCard() : emptyState()}
    </Grid>
  );
};

export default AnalyticsCard;
